export class AllergenFoodModel {
    constructor(
        public allergenTypeCode?: string,
        public levelOfContainmentCode: any = null
    ) {
    }
}
